import ContextMenu from './ContextMenu';
import EventEmitter from './EventEmitter';
import Utils from './Utils';

class ComboBox extends EventEmitter {
    static fromSelectElement(selectElement, options = {}) {
        const mainWrapperElement = document.createElement('div');
        mainWrapperElement.className = 'combobox';

        if (options.compact === true) {
            mainWrapperElement.className += ' combobox-compact';
        }

        const substituteAnchorElement = document.createElement('a');
        substituteAnchorElement.className = 'combobox-substitute';
        substituteAnchorElement.href = 'javascript://';

        const contextMenuElement = document.createElement('div');
        contextMenuElement.className = 'combobox-menu context-menu';

        const menuItemWrapperElement = document.createElement('div');
        menuItemWrapperElement.className = 'menu-item-wrapper';

        const hiddenValueElement = document.createElement('input');
        hiddenValueElement.type = 'hidden';
        substituteAnchorElement.appendChild(hiddenValueElement);
        Utils.copyElementAttributes(selectElement, hiddenValueElement);

        const replacementInputElement = document.createElement('input');
        replacementInputElement.type = 'text';
        replacementInputElement.classList.add('textbox');
        replacementInputElement.autocomplete = 'off';
        replacementInputElement.readOnly = true;
        replacementInputElement.title = '';
        replacementInputElement.value = 'Please choose...';

        substituteAnchorElement.appendChild(replacementInputElement);
        mainWrapperElement.appendChild(substituteAnchorElement);

        contextMenuElement.appendChild(menuItemWrapperElement);
        mainWrapperElement.appendChild(contextMenuElement);

        const instance = new ComboBox(mainWrapperElement, options);

        for (let i = 0; i < selectElement.options.length; i++) {
            instance.addItem(selectElement.options[i].text, selectElement.options[i].value);
        }

        instance.setValue(selectElement.value, false);

        if (!!selectElement.parentNode) {
            // If inserted into the DOM, remove it
            selectElement.parentNode.insertBefore(mainWrapperElement, selectElement);
            selectElement.parentNode.removeChild(selectElement);
        }

        return instance;
    }

    constructor(domElement, options = {}) {
        super();

        this.domElement = domElement || null;
        this.contextMenuDomElement = this.domElement.getElementsByClassName('combobox-menu')[0];
        this.contextMenuItemDomElements = this.contextMenuDomElement.getElementsByClassName('menu-item');

        this.substituteDomElement = this.domElement.getElementsByClassName('combobox-substitute')[0];
        this.substituteTextDomElement = this.substituteDomElement.querySelector('input[type="text"]');
        this.substituteValueDomElement = this.substituteDomElement.querySelector('input[type="hidden"]');

        const ContextMenuClass = options['contextMenuClass'] || ContextMenu;
        this.contextMenu = new ContextMenuClass(this.contextMenuDomElement, this.substituteDomElement, {
            positionToTriggerCenter: false,
            dataSource: options.dataSource,
            enableSearch: options.enableSearch,
            searchUrl: options.searchUrl,
            searchUrlQueryFieldName: options.searchUrlQueryFieldName,
            searchUrlAdditionalFields: options.searchUrlAdditionalFields,
        });

        this.bindEvents();

        // Might look like a hack, but this actually ensures that the selected value on screen matches the value of the subtitute hidden element
        this.setValue(this.getValue(), false);
    }

    bindEvents() {
        this.contextMenu.addEventListener('item_click', this.onContextMenuItemClick.bind(this));
        this.contextMenu.addEventListener('loaded', this.onContextMenuLoaded.bind(this));
    }

    addItem(label, id = null) {
        this.contextMenu.addItem(label, id);
    }

    getItemByValue(value) {
        for (let i = 0; i < this.contextMenuItemDomElements.length; i++) {
            if ('value' in this.contextMenuItemDomElements[i].dataset) {
                if (this.contextMenuItemDomElements[i].dataset.value === value) {
                    return this.contextMenuItemDomElements[i];
                }
            } else {
                if (this.contextMenuItemDomElements[i].textContent === value) {
                    return this.contextMenuItemDomElements[i];
                }
            }
        }

        return null;
    }

    setValue(value, emitEvent = true) {
        const menuItem = this.getItemByValue(value);
        if (!menuItem) {
            return;
        }

        if (!!this.substituteValueDomElement) {
            this.substituteValueDomElement.value = menuItem.dataset.value;
        }

        this.substituteTextDomElement.value = menuItem.textContent;

        if (emitEvent === true) {
            this.emit({
                type: 'value_change',
                value: menuItem.dataset.value || menuItem.textContent,
                text: menuItem.textContent,
            });
        }
    }

    getValue() {
        if (!!this.substituteValueDomElement) {
            return this.substituteValueDomElement.value;
        }

        return this.substituteTextDomElement.value;
    }

    onContextMenuItemClick(e) {
        this.contextMenu.hide();
        this.setValue(e.value || e.text);
    }

    onContextMenuLoaded(e) {
        // When data has changed, reset the current value to make sure it still exists
        this.setValue(this.getValue(), false);
    }
}

export default ComboBox;
